import { Product } from 'state/product'
import { Color } from 'state/color'
import { config } from 'state/product/config'
import { sort } from 'state/product/listeners/sort'
// import { changeProductView } from 'state/product/listeners/changeProductView'

MK.events.on('products:initialize', (event = {}) => {
  console.log('DEBUG (products:initialize): Attempting product initialization.')
  const index = event.target || {}

  try {
    Product.container = document.getElementById(config.selectors.id.container)

    if (!index.products || !index.colors || !Product.container) throw new Error(`Aborting product initialization.  Requirements not met.  URL: ${window.location.href}`)

  } catch (error) {
    console.log('!!! ERROR (products:initialize) Error encountered during Product initialization.')
    console.log(error)
    MK.captureException(error)
    return
  }

  try {
    let sortOrder = 0
    // Initialize product instances
    index.products.forEach(product => {
      try {
        product.sortOrder = sortOrder++
        // product.type = 'id'
        if (!product.p || !product.p[0]) throw new Error(`Error! Product ID ${product.id} missing price on ${window.location.href}.`)
        new Product(product)
      } catch (error) {
        console.log(error)
        console.log(product)
        MK.captureException(error)
      }
    })

    // Add product nodes to DOM
    if (MK.page && MK.page.is && !MK.page.is.outOfStock) {
      MK.events.emit('products:updateDOM', {
        initiator: 'products:initialize',
        initialLoad: true
      })
    }

    // Initialize event listeners
    Product.listeners = {
      sort: sort.initialize(Product),
      // changeProductView: changeProductView.initialize(Product)
    }

    console.log(`DEBUG (products:initialize): Products / Total IDs: ${Object.keys(Product.index.ids).length} / SKUs: ${Object.keys(Color.by.alias).length}`)


  } catch (error) {
    console.log('!!! ERROR (products:initialize) Error encountered during Product initialization.')
    console.log(error)
    MK.captureException(error)
  }
})